<script>
/** DEPRECATED
 *  This mixin was deprectated in favor of Fabricjs-with-gestures which does gestures just out of the box.
*/
import * as Hammer from 'hammerjs';

export default {
  name: 'Pinch',
  data() {
    return {
      pinch: {},
      initial_scale: 1.0,
    };
  },
  methods: {
    activatePinch() {
      if (!this.canvas) {
        console.error('Attempting to activate pinch mixin with no this.canvas property');
        return;
      }
      const hammertime = new Hammer(this.canvas.upperCanvasEl, {});
      hammertime.get('pinch').set({ enable: true });
      hammertime.on('pinchstart', (ev) => {
        const active = this.canvas.getActiveObject();
        this.deactivateObjects();
        this.pinch = ev;
        this.initial_scale = active.scaleX;
        return false;
      });

      hammertime.on('pinchmove', (ev) => {
        const active = this.canvas.getActiveObject();
        active.left += ev.center.x - this.pinch.center.x;
        active.top += ev.center.y - this.pinch.center.y;
        active.set({
          scaleY: this.initial_scale * ev.scale,
          scaleX: this.initial_scale * ev.scale,
        });
        active.angle += ev.rotation - this.pinch.rotation;
        this.canvas.renderAll();
        this.pinch = ev;
        return false;
      });

      hammertime.on('pinchend', () => {
        this.activateObjects();
        return false;
      });

      hammertime.on('press', (evt) => {
        this.longpress(evt);
      });
    },
    deactivateObjects() {
      this.canvas.getObjects().forEach((i) => {
        i.selectable = false;
        i.evented = false;
        i.lockMovementX = true;
        i.lockMovementY = true;
      });
    },
    activateObjects() {
      this.canvas.getObjects().forEach((i) => {
        i.selectable = true;
        i.evented = true;
        i.lockMovementX = false;
        i.lockMovementY = false;
      });
    },
    longpress() {
      console.log('LONGPRESS: Not implemented');
    },

  },
};
</script>
